<script lang="ts">
import type { DailySpinProgress } from '@/types'
import { DateTime } from 'luxon'
import { type PropType, defineComponent } from 'vue'

import IconCheck from '../icons/IconCheck.vue'
import IconTimes from '../icons/IconTimes.vue'

/**
 * WeeklyProgress
 */
export default defineComponent({
  components: {
    IconTimes,
    IconCheck,
  },
  props: {
    progress: {
      type: Object as PropType<DailySpinProgress[]>,
      required: true,
    },
  },
  computed: {
    currentDayOfTheWeek(): number {
      return this.$userStore.isLoggedIn ? DateTime.now().weekday : 0
    },
  },
})
</script>

<template>
  <div
    class="weekly-progress grid w-full grid-cols-7 gap-1 bg-primary-lighter p-1 rounded-lg !px-2"
  >
    <div
      v-for="weekday in progress"
      :key="weekday.day_number"
      class="flex flex-col items-center justify-center py-2"
    >
      <div class="text-2xs font-bold uppercase sm:text-xs">
        {{ weekday.day_name }}
      </div>

      <div
        class="mt-1 flex size-5 items-center justify-center rounded-full p-1 sm:size-6"
        :class="{
          'bg-red-500':
            weekday.day_number < currentDayOfTheWeek && !weekday.is_played,
          'bg-green-700':
            weekday.day_number <= currentDayOfTheWeek && weekday.is_played,
          'border border-[#B6C6CF]':
            weekday.day_number > currentDayOfTheWeek ||
            (weekday.day_number === currentDayOfTheWeek && !weekday.is_played),
        }"
      >
        <IconTimes
          v-if="weekday.day_number < currentDayOfTheWeek && !weekday.is_played"
          class="size-4 stroke-1 text-black"
          :stroke-width="2"
        />

        <IconCheck
          v-if="weekday.day_number <= currentDayOfTheWeek && weekday.is_played"
          class="size-5 text-pure-white"
          :stroke-width="1"
          stroke-color="white"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
